import {
  FaVideo,
  FaCamera,
  FaFilm,
  FaBoxOpen,
  FaCameraRetro,
  FaBullhorn,
  FaPenNib,
  FaMagic,
  FaPalette,
  FaInstagram,
} from "react-icons/fa";

import "./Services.css";

function Services() {
  const services = [
    {
      icon: <FaVideo />,
      title: "Video Editing",
      desc: "Professional editing with smooth transitions, sound design and cinematic storytelling.",
    },
    {
      icon: <FaCamera />,
      title: "Cinematography",
      desc: "Creative camera work that captures emotions and tells powerful stories.",
    },
    {
      icon: <FaFilm />,
      title: "Filmmaking",
      desc: "End-to-end filmmaking from concept development to final production.",
    },
    {
      icon: <FaBoxOpen />,
      title: "Product Videography",
      desc: "High-quality product videos designed to increase engagement and sales.",
    },
    {
      icon: <FaCameraRetro />,
      title: "Product Photography",
      desc: "Professional product photography for brands, e-commerce and advertising.",
    },
    {
      icon: <FaBullhorn />,
      title: "Brand Shoots",
      desc: "Creative visual content that strengthens brand identity and recognition.",
    },
    {
      icon: <FaPenNib />,
      title: "Content Creation",
      desc: "Engaging content tailored for social media and digital platforms.",
    },
    {
      icon: <FaMagic />,
      title: "Visual Storytelling",
      desc: "Turning ideas into impactful visual experiences that connect with audiences.",
    },
    {
      icon: <FaPalette />,
      title: "Colour Grading",
      desc: "Professional color correction and cinematic grading for a polished look.",
    },
    {
      icon: <FaInstagram />,
      title: "Reels Editing",
      desc: "Fast-paced and engaging edits optimized for Instagram, TikTok and Shorts.",
    },
  ];

  return (
    <section className="services-section">
      <div className="services-container">

        <span className="services-tag">WHAT I OFFER</span>

        <h1>Professional Services</h1>

        <p className="services-desc">
          Helping brands, creators and businesses stand out through
          cinematic visuals, creative storytelling and premium editing.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                {service.icon}
              </div>

              <h3>{service.title}</h3>

              <p>{service.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Services;